module.exports = __webpack_public_path__ + "static/media/How can your client upload documents in document checklist.41c21f52.png";